'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalConsumer = exports.ModalProvider = exports.ModalContext = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ModalContext = exports.ModalContext = _react2.default.createContext();

var MODAL_FADING_IN = 'MODAL_FADING_IN';
var MODAL_FADING_OUT = 'MODAL_FADING_OUT';
var defaultState = {
  // providing to consumer
  hasDetectedFormChange: false,
  isDisplayingUnsavedModal: false,
  modalComponent: null,
  // modal displays if it's not null
  overlayStyle: null,
  // handles fading of consumer modal-overlay top tag
  showModal: false,
  className: null,
  // for internal use
  fadeInDuration: 0,
  fadeOutDuration: 0,
  fadingState: null,
  // if not null then it's in fading transition
  prevActiveElement: null,
  skipLayout: false,
  // if true then skip all inner layout of ModalOverlay (Close icon, container, etc) and output modalComponent as-is
  overwriteOutsideClick: null // if given a different function will run that instead of clearing the modal

};

var ModalProvider = exports.ModalProvider = function (_Component) {
  _inherits(ModalProvider, _Component);

  function ModalProvider(props) {
    _classCallCheck(this, ModalProvider);

    var _this = _possibleConstructorReturn(this, (ModalProvider.__proto__ || Object.getPrototypeOf(ModalProvider)).call(this, props));

    _this.hideUnsavedModal = function () {
      if (_this.state.isDisplayingUnsavedModal) {
        _this.setState({
          isDisplayingUnsavedModal: false
        });
      }
    };

    _this.clearDetectModalFormChange = function () {
      _this.setState({
        hasDetectedFormChange: false
      });
    };

    _this.clearModal = function () {
      var hasDetectedFormChange = _this.state.hasDetectedFormChange;

      if (hasDetectedFormChange) {
        _this.displayUnsavedModal(true);
      } else {
        _this.hide();
      }
    };

    _this.detectModalFormChange = function () {
      var _this$state = _this.state,
          hasDetectedFormChange = _this$state.hasDetectedFormChange,
          modalComponent = _this$state.modalComponent;

      if (modalComponent && !hasDetectedFormChange) {
        _this.setState({
          hasDetectedFormChange: true
        });
      }
    };

    _this.displayUnsavedModal = function (value) {
      _this.setState({
        isDisplayingUnsavedModal: value
      });
    };

    _this.handleKeyDown = function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();

        if (_this.state.isDisplayingUnsavedModal) {
          _this.hideUnsavedModal();
        } else {
          _this.clearModal();
        }
      } else if (e.key === 'Tab' && _this.endRef.current) {
        if (e.shiftKey) {
          if (document.activeElement === _this.startRef.current) {
            e.preventDefault();

            _this.endRef.current.focus();
          } // TAB

        } else if (document.activeElement === _this.endRef.current) {
          e.preventDefault();

          _this.startRef.current.focus();
        }
      }
    };

    _this.handleOutsideClick = function (e) {
      var overwriteOutsideClick = _this.state.overwriteOutsideClick;
      e.preventDefault();
      e.stopPropagation();

      if (overwriteOutsideClick) {
        overwriteOutsideClick();
      } else if (!_this.state.isDisplayingUnsavedModal) {
        _this.clearModal();
      }
    };

    _this.showModalComponent = function (modalComponent) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fadingState = _this.state.fadingState;
      if (fadingState || _this.timeoutToken) return;
      var _options$fadeInDurati = options.fadeInDuration,
          fadeInDuration = _options$fadeInDurati === undefined ? 0 : _options$fadeInDurati,
          _options$fadeOutDurat = options.fadeOutDuration,
          fadeOutDuration = _options$fadeOutDurat === undefined ? 0 : _options$fadeOutDurat,
          _options$skipLayout = options.skipLayout,
          skipLayout = _options$skipLayout === undefined ? false : _options$skipLayout,
          className = options.className,
          overwriteOutsideClick = options.overwriteOutsideClick;
      var prevActiveElement = document.activeElement;

      _this.setState({
        // providing to consumer
        modalComponent: modalComponent,
        overlayStyle: {
          opacity: 1,
          transition: fadeInDuration ? 'opacity ease ' + fadeInDuration + 'ms' : 'initial'
        },
        // for internal use
        fadeInDuration: fadeInDuration,
        fadeOutDuration: fadeOutDuration,
        fadingState: fadeInDuration ? MODAL_FADING_IN : null,
        prevActiveElement: prevActiveElement,
        skipLayout: skipLayout,
        className: className,
        overwriteOutsideClick: overwriteOutsideClick
      }); // in fadeInDuration msecs reset fadingState


      if (fadeInDuration) {
        _this.timeoutToken = setTimeout(function () {
          _this.setState({
            fadingState: null
          }); // reset timeout token


          _this.timeoutToken = null;
        }, fadeInDuration);
      }
    };

    _this.hide = function () {
      var _this$state2 = _this.state,
          fadingState = _this$state2.fadingState,
          _this$state2$fadeOutD = _this$state2.fadeOutDuration,
          fadeOutDuration = _this$state2$fadeOutD === undefined ? 0 : _this$state2$fadeOutD,
          modalComponent = _this$state2.modalComponent,
          prevActiveElement = _this$state2.prevActiveElement;
      if (fadingState || _this.timeoutToken) return;

      if (!!prevActiveElement && !!prevActiveElement.focus) {
        prevActiveElement.focus();
      }

      if (fadeOutDuration) {
        _this.setState({
          overlayStyle: {
            opacity: 0,
            transition: 'opacity ease ' + fadeOutDuration + 'ms'
          },
          fadingState: MODAL_FADING_OUT
        }); // in fadeOutDuration msecs reset state


        _this.timeoutToken = setTimeout(function () {
          _this.setState(_extends({}, defaultState, {
            overlayStyle: {
              opacity: 0,
              transition: 'initial'
            }
          })); // reset timeout token


          _this.timeoutToken = null;
        }, fadeOutDuration);
      } else {
        modalComponent && _this.setState(_extends({}, defaultState));
      }
    };

    _this.startRef = _react2.default.createRef();
    _this.endRef = _react2.default.createRef();
    _this.state = defaultState;
    _this.timeoutToken = null;
    return _this;
  }

  _createClass(ModalProvider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyDown);
      this.timeoutToken && clearTimeout(this.timeoutToken);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          modalComponent = _state.modalComponent,
          overlayStyle = _state.overlayStyle,
          isDisplayingUnsavedModal = _state.isDisplayingUnsavedModal,
          showModal = _state.showModal,
          skipLayout = _state.skipLayout,
          className = _state.className;
      return _react2.default.createElement(ModalContext.Provider, {
        value: {
          className: className,
          hideUnsavedModal: this.hideUnsavedModal,
          clearDetectModalFormChange: this.clearDetectModalFormChange,
          clearModal: this.clearModal,
          detectModalFormChange: this.detectModalFormChange,
          displayUnsavedModal: this.displayUnsavedModal,
          endRef: this.endRef,
          handleOutsideClick: this.handleOutsideClick,
          hide: this.hide,
          isDisplayingUnsavedModal: isDisplayingUnsavedModal,
          isOpen: showModal,
          modalComponent: modalComponent,
          overlayStyle: overlayStyle,
          showModalComponent: this.showModalComponent,
          skipLayout: skipLayout,
          startRef: this.startRef
        }
      }, this.props.children);
    }
  }]);

  return ModalProvider;
}(_react.Component);

var ModalConsumer = exports.ModalConsumer = ModalContext.Consumer;